import React from 'react';
import {Button} from 'ui/Button';
import {Drawer} from 'shared/ui/Drawer';

export type DeclineTaskDrawerProps = {
	open: boolean;
	step: 'confirm' | 'success';
	onClose: () => void;
	onConfirm: () => void;
	onContinue: () => void;
	isLoading?: boolean;
};

export function DeclineTaskDrawer({
	open,
	step,
	onClose,
	onConfirm,
	onContinue,
	isLoading,
}: DeclineTaskDrawerProps): React.ReactElement {
	if (step === 'success') {
		return (
			<Drawer
				open={open}
				onClose={onClose}
				title={'Заказ отклонен'}
				titleIcon={
					<svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
						<g clip-path="url(#clip0_26916_79793)">
							<path
								fill-rule="evenodd"
								clip-rule="evenodd"
								d="M82.574 13.0439H100L38.8646 87.0271L10.793 45.4291H26.9979L39.9492 64.6206L82.574 13.0439ZM83.0518 14.0585L39.867 66.3127L26.4586 46.4437H12.7017L38.9467 85.335L97.8456 14.0585H83.0518Z"
								fill="black"
							/>
							<path
								d="M38.8567 87.0945L38.8787 86.1361L25.3243 66.0551L11.7479 45.9355L11.2853 45.3848H0L27.9184 87.0945H38.8567Z"
								fill="black"
							/>
							<path d="M71.9317 13L34.8154 57.9151L39.91 65.4662L83.2665 13H71.9317Z" fill="black" />
						</g>
						<defs>
							<clipPath id="clip0_26916_79793">
								<rect width="100" height="100" fill="white" />
							</clipPath>
						</defs>
					</svg>
				}
				footerContent={
					<Button type="button" className="!w-full !h-[60px]" onClick={onContinue}>
						Продолжить
					</Button>
				}
			>
				<p className="text-black/55">Мы сообщим заказчику, что вы не хотите выполнять работы по этому заказу</p>
			</Drawer>
		);
	}
	return (
		<Drawer
			open={open}
			onClose={onClose}
			title={'Отклонить заказ?'}
			footerContent={
				<Button
					type="button"
					className="!w-full !h-[60px]"
					onClick={onConfirm}
					disabled={Boolean(isLoading)}
					isLoading={Boolean(isLoading)}
				>
					Отклонить
				</Button>
			}
		>
			<p className="text-black/55">Подтвердите, что вы точно хотите отклонить заказ</p>
		</Drawer>
	);
}
